module.exports = __webpack_public_path__ + "static/media/kia-vest.5446c600.svg";